import { ShopOutlined, InboxOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { Link } from "react-router-dom";

const { Sider } = Layout;
interface SidebarProps {
  collapsed: boolean;
}

const Sidebar = ({ collapsed }: SidebarProps) => {
  return (
    <Sider
      width={collapsed ? 80 : 200} // Shrinks the sidebar when collapsed
      className="site-layout-background"
      collapsed={collapsed}
      style={{ marginTop: 64 }}
      breakpoint="lg" // Automatically collapses on smaller screens
      collapsedWidth={0} // Hides sidebar on collapse
    >
      <Menu
        mode="inline"
        theme="light"
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["sub1"]}
        style={{ height: "100%", borderRight: 0 }}
      >
        <Menu.Item key="1" icon={<ShopOutlined />}>
          <Link to="/outlet">Outlet</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<InboxOutlined />}>
          <Link to="/machine">Machine</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
